import { t } from '../../../i18n'
import { Tab } from '../../Tab'
import { Attachment } from './Attachment'
import { Messages } from './Messages'

export const Approved = () => {
  return (
    <>
      <Tab
        tabs={[
          t('pages.step5.quotation.tabs.message'),
          t('pages.step5.quotation.tabs.attachment'),
        ]}
        pages={[<Messages />, <Attachment />]}
      />
    </>
  )
}
